import { css } from '@emotion/core';
import { media, tokens, shadow } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
export var agencies = {
  name: "dk1c2q",
  styles: "margin:24px 0;max-width:660px;"
};
export var heading = /*#__PURE__*/css(designTokenFonts.displayMedium);
export var subHeading = /*#__PURE__*/css(designTokenFonts.body);
export var cardsContainer = {
  name: "79elbk",
  styles: "position:relative;"
};
export var cardList = {
  name: "ncaihl",
  styles: "display:flex;flex-direction:row;overflow:auto hidden;-ms-overflow-style:none;scrollbar-width:none;margin-top:8px;::-webkit-scrollbar{display:none;}"
};
export var card = {
  name: "14vvkwf",
  styles: "min-width:311px;&:not(:last-of-type){margin-right:8px;}"
};
var scrollBtn = /*#__PURE__*/css("position:absolute;top:50%;transform:translateY(-50%);background:none;border:0;outline:0;width:40px;height:40px;background-color:", tokens.colors.neutral.surface.default, ";box-shadow:", shadow(tokens.shadows.elevation4), ";border-radius:50%;z-index:2;transition:opacity 0.3s;");
export var scrollBtnLeft = /*#__PURE__*/css(scrollBtn, " left:10px;");
export var scrollBtnRight = /*#__PURE__*/css(scrollBtn, " right:10px;");
export var scrollButtonIcon = /*#__PURE__*/css("display:flex;color:", tokens.colors.neutral.medium.default, ";padding:0;width:30px;height:16px;cursor:pointer;", media('>=desktop'), "{&:hover{color:", tokens.colors.interactive.base.default, ";}}");
export var viewAllLink = /*#__PURE__*/css("margin-top:8px;width:200px;", media('<tablet'), "{width:100%;}");